import React from 'react';
import { Link } from 'react-router-dom';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';

const BlogSingle = props => {
	const { slug } = useParams();

	const NewsDetails = blogs.find(item => item.slug === slug);

	const submitHandler = e => {
		e.preventDefault();
	};

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='py-[120px] md:py-[90px] sm:py-[80px]'>
			<div className='wraper'>
				<div className={`${props.gClass} grid gap-3`}>
					<div className={`col-span-8 md:col-span-12 ${props.blRight}`}>
						<div className=''>
							<div className='mb-[70px]'>
								<h3 className='text-[34px] md:text-[25px] sm:text-[22px] text-[#282e3f] font-normal font-heading-font leading-[40px] pt-7 transition-all mb-[20px] group'>
									{NewsDetails.title} : une initiative essentielle du Barreau de Charleroi
								</h3>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									{NewsDetails.description}
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Conscient de cette réalité, le <strong>Barreau de Charleroi</strong>, par
									l'intermédiaire de sa <strong>Commission Violences Intrafamiliales (VIF)</strong>{' '}
									dont Me VAN WYMEERSCH fait partie, a mis en place un nouveau dispositif destiné à
									offrir une écoute, une information juridique et un accompagnement rapide aux
									personnes confrontées à ce type de violences.
								</p>
								<h4
									className='text-[#666] text-[21px] mt-[40px] mb-[20px] font-semibold'
									style={{ fontFamily: 'Open Sans, sans-serif' }}
								>
									Un accompagnement confidentiel par un avocat
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Toute personne concernée peut prendre contact avec le dispositif afin d'être écoutée
									en toute confidentialité.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Après un premier échange, un avocat est désigné pour rappeler la victime dans un
									délai de 24 heures. Si nécessaire, un rendez-vous est organisé dans les huit jours
									afin d'examiner sa situation, de répondre à ses questions et de l'informer de
									manière claire sur ses droits ainsi que sur les démarches envisageables.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									L'ensemble des échanges est naturellement couvert par le secret professionnel de
									l'avocat, garantissant une confidentialité absolue.
								</p>
								<h4
									className='text-[#666] text-[21px] mt-[40px] mb-[20px] font-semibold'
									style={{ fontFamily: 'Open Sans, sans-serif' }}
								>
									Une aide juridique accessible
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									La première consultation peut être facturée par l'avocat, dans la limite de{' '}
									<strong>50 € HTVA maximum</strong>, permettant ainsi un accès rapide à un conseil
									juridique de qualité à un coût limité.
								</p>
								<h4
									className='text-[#666] text-[21px] mt-[40px] mb-[20px] font-semibold'
									style={{ fontFamily: 'Open Sans, sans-serif' }}
								>
									Informations pratiques
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									<strong>Permanence téléphonique :</strong>
									<ul>
										<li>• Lundi, mardi, mercredi et vendredi de 13h à 16h. </li>
										<li>
											• En dehors de ces heures, il est possible de laisser un message afin d'être
											rappelé.
										</li>
									</ul>
									<br />
									<strong>Coordonnées :</strong>
									<ul>
										<li>• Téléphone : 0476 600 696</li>
										<li>• Adresse e-mail : avc@barreaudecharleroi.be</li>
									</ul>
								</p>
								<h4
									className='text-[#666] text-[21px] mt-[40px] mb-[20px] font-semibold'
									style={{ fontFamily: 'Open Sans, sans-serif' }}
								>
									Le cabinet GAVA-LEX soutient cette initiative
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Chez <strong>GAVA-LEX</strong>, nous saluons la mise en place de ce dispositif, qui
									constitue une avancée importante pour améliorer l'accès à la justice des victimes de
									violences intrafamiliales.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Être correctement informé de ses droits est souvent la première étape indispensable
									pour sortir d'une situation de violence. Un accompagnement juridique précoce permet
									d'envisager les mesures de protection existantes, d'être orienté vers les services
									compétents et de prendre des décisions en toute connaissance de cause.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Si vous êtes concerné ou si l'un de vos proches traverse une telle situation,
									n'hésitez pas à solliciter cette permanence. Vous ne devez pas affronter ces
									difficultés seul.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BlogSingle;
